const Finance = () => {
    return (
        <>
            Finance
        </>
    )

};

export default Finance;